module.exports = __webpack_public_path__ + "assets/img/events-point-04.1575d93b.png";